import React, { useEffect, useRef } from "react";
import {
  NewNewFormComponent,
  NewNewFormComponentProps,
} from "../new_form/NewNewFormComponent";
import { NewSingleFormComponentProps } from "../new_form/NewSingleFormComponent";
import { Button, Icon } from "semantic-ui-react";

export type ListPageFilterComponentProps = {
  form: NewSingleFormComponentProps;
  startingData: any;
};

export const ListPageFilterComponent = (props: {
  props: ListPageFilterComponentProps;
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const wrapperRef = useRef<HTMLDivElement>(null);
  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      style={{ position: "relative", display: "inline-block" }}
    >
      <Button
        icon
        labelPosition="left"
        color="grey"
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
      >
        <Icon name="filter" />
        Filter
      </Button>

      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "0.5rem",
            padding: "1rem",
            background: "white",
            border: "1px solid #ddd",
            borderRadius: "0.5rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            gap: "0.75rem",
            minWidth: "220px",
          }}
        >
          <NewNewFormComponent
            props={
              new NewNewFormComponentProps({
                form: props.props.form,
                startingData: props.props.startingData,
              })
            }
            data={props.data}
            setData={props.setData}
          />
        </div>
      )}
    </div>
  );
};
